exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RIGcontainer{background-image:url(/images/rig.jpg);height:800px;background-size:cover;background-repeat:no-repeat}.RIGcontainer .RIGheading{font-size:2.9em;width:40%;color:white;padding:30px;margin-left:150px;padding-top:80px}.RIGcontainer .RIGheading span{color:#ffc000}.RIGcontainer .RIGButton-container{height:30px;color:white;font-size:1.5em;margin-top:180px}.RIGcontainer .RIGButton-container .RIGButton{float:right;padding:20px;margin-right:60px;border:1px solid #ffc000;cursor:pointer}.RIGcontainer .RIGButton-container .RIGButton span{color:#ffc000}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Retire/intro.scss
// module id = 1537
// module chunks = 0